import axios from 'axios'
import { url } from './url'
import queryStringUtil from "query-string";

function queryString(query) {
    var queryParams = {
       ...query
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function getDeviceTypes(){
    return axios.get(`${url}/device/types`)
    .then(resp => {
        return resp.data
    })
}

function getDevices(query) {
    var urlString = `${url}/device?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                devices: res.data.devices.map(device => {
                    return {
                        _id: device._id,
                        macAddress: device.macAddress,
                        customer: device.customer,
                        type: device.type,
                        version: device.version,
                        versionRequestedAt: device.versionRequestedAt,
                        createdAt: device.createdAt,
                        availableGateways:device.availableGateways
                    };
                })
            }
        });
}

function createDevice(device) {
    return axios.post(`${url}/device`, device)
        .then(resp => {
            return resp.data
        })
}
function deleteDevice(id) {
    return axios.delete(`${url}/device/${id}`)
        .then(resp => {
            return resp.data
        })
}
function updateDevice(device) {
    return axios.put(`${url}/device/${device._id}`, device)
        .then(resp => {
            return resp.data
        })
}
export default {
    getDevices,
    createDevice,
    deleteDevice,
    updateDevice,
    getDeviceTypes
};